/**
 * Textos do vue-pagination-2. As tres variantes de `count` sao escolhidas pelo
 * proprio componente: 1 registro, uma pagina so, ou o caso geral.
 *
 * `format: false` porque o separador de milhar dele e a virgula.
 */
export default {
  format: false,
  texts: {
    count: 'Mostrando {from} a {to} de {count} registros|{count} registros|1 registro',
    first: 'Primeira',
    last: 'Última',
    nextPage: '>',
    nextChunk: '>>',
    prevPage: '<',
    prevChunk: '<<',
  },
}
